// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__4w6KY","title":"Info_title__15Lkv","selects":"Info_selects__2Y_cM","requiredAsterisk":"Info_requiredAsterisk__2PTWf"};